module.exports = __webpack_public_path__ + "img/petmenu_infoicon.1d83c94d.svg";